export default __webpack_public_path__ + "static/media/dvd.2255c664.png";